


























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component<Difficulty>({})
export default class Difficulty extends Vue {
  @Prop({ required: true })
  difficultyLevels: number;
  @Prop({ required: true })
  selected: number;

  maxDifficultyLevels = 3;

  selectDifficulty(level: number) {
    if (level > this.difficultyLevels) {
      return;
    }
    this.$emit("difficulty-selected", level);
  }

  getDifficultyDescription(difficulty: number): string {
    switch (difficulty) {
      case 1: {
        return "leicht";
      }
      case 2: {
        return "mittelschwer";
      }
      case 3: {
        return "schwer";
      }
      default: {
        return "keine Angabe";
      }
    }
  }
  getLockedDescription(locked: boolean): string {
    return locked ? "(nicht vorhanden)" : "";
  }

  get displayDifficultyLevels(): number {
    return Math.min(this.difficultyLevels, this.maxDifficultyLevels);
  }
}
